import React from 'react';
import { Card, Tag, Button, Popconfirm, Typography, Row, Col } from 'antd';
import { EditOutlined, DeleteOutlined, RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../../utils/formatters';
import { FARM_PHOTO } from '../../utils/constants';

const { Text, Title } = Typography;

export default function FarmCard({ farm, onEdit, onDelete }) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const expense = farm.expanse || 0;
  const selling = farm.selling || 0;
  const profit = selling - expense;
  const isProfit = profit >= 0;

  return (
    <Card
      hoverable
      cover={farm.photo ? <img src={FARM_PHOTO(farm.photo)} alt={farm.name} style={{ height: 130, objectFit: 'cover' }} /> : null}
      style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #e8e8e8' }}
      actions={[
        <Button type="text" icon={<EditOutlined />} onClick={(e) => { e.stopPropagation(); onEdit(farm); }}>{t('edit')}</Button>,
        <Popconfirm title="Delete this farm?" onConfirm={(e) => { e?.stopPropagation(); onDelete(farm.id); }} okButtonProps={{ danger: true }}>
          <Button type="text" danger icon={<DeleteOutlined />}>{t('delete')}</Button>
        </Popconfirm>,
        <Button type="text" icon={<RightOutlined />} onClick={() => navigate(`/farms/${farm.id}/farm`)}>Crops</Button>,
      ]}
    >
      <div onClick={() => navigate(`/farms/${farm.id}/farm`)} style={{ cursor: 'pointer' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
          <Title level={5} style={{ margin: 0, textTransform: 'capitalize' }}>{farm.name}</Title>
          <Tag color={isProfit ? 'green' : 'red'}>{isProfit ? t('profit') : t('loss')}</Tag>
        </div>
        {/* {farm.location ? (
          <Text type="secondary" style={{ fontSize: 12 }}>📍 {farm.location}</Text>
        ) : null} */}
        <div style={{ marginTop: 4 }}>
          <Text style={{ fontSize: 12 }}>🌱 {farm.cropCount || 0} crops</Text>
        </div>
        <Row gutter={8} style={{ marginTop: 12 }}>
          <Col span={8}>
            <div style={{ textAlign: 'center', background: '#fff7e6', borderRadius: 6, padding: '4px 0' }}>
              <div style={{ fontSize: 11, color: '#888' }}>Expense</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#fa8c16' }}>{formatCurrency(expense)}</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ textAlign: 'center', background: '#f6ffed', borderRadius: 6, padding: '4px 0' }}>
              <div style={{ fontSize: 11, color: '#888' }}>Selling</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#52c41a' }}>{formatCurrency(selling)}</div>
            </div>
          </Col>
          <Col span={8}>
            <div style={{ textAlign: 'center', background: isProfit ? '#f6ffed' : '#fff1f0', borderRadius: 6, padding: '4px 0' }}>
              <div style={{ fontSize: 11, color: '#888' }}>{isProfit ? t('profit') : t('loss')}</div>
              <div style={{ fontSize: 13, fontWeight: 600, color: isProfit ? '#52c41a' : '#ff4d4f' }}>{formatCurrency(Math.abs(profit))}</div>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
  );
}
